function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23 11.507a.748.748 0 00-.21-.514l-7.115-7.186a.714.714 0 00-1.017 0 .73.73 0 000 1.026l5.889 5.948H.719a.722.722 0 00-.719.726c0 .4.322.725.719.725h19.827l-5.888 5.948a.73.73 0 00.233 1.183.713.713 0 00.784-.157l7.114-7.186a.744.744 0 00.211-.513z",
  fill: "#1D3C34"
});

function SvgIconArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 23 23",
    fill: "none"
  }, props), _ref);
}

export default SvgIconArrowRight;